module.exports = __webpack_public_path__ + "media/images/multibrands_store-d3138e7c3bf190bb4614def912e6eace.png";